var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3487 9.61182L17.5723 14.3882",
    stroke: "#B2B2B2",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5723 9.61182L22.3487 14.3882",
    stroke: "#B2B2B2",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63075 8.81574H3.24253C2.37482 8.81574 1.65039 9.54016 1.65039 10.4079V13.5922C1.65039 14.4599 2.37482 15.1843 3.24253 15.1843H5.63075L11.856 19.6582C12.883 20.3699 14.3605 19.62 14.3875 18.3686V5.63145C14.3958 5.35005 14.3257 5.07189 14.185 4.82802C14.0444 4.58415 13.8387 4.38417 13.591 4.25041C13.3433 4.11664 13.0633 4.05435 12.7822 4.07049C12.5011 4.08663 12.2301 4.18057 11.9993 4.34181L5.63075 8.81574Z",
    stroke: "#B2B2B2",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/Volume Mute.85cd0212fabb0495be9cb7875c66eada.svg";
export { ForwardRef as ReactComponent };